import { type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { getAccessToken } from '../../utils/helper';

interface RouteWrapperProps {
  children: ReactNode;
}

/**
 * VoluntaryInsuranceRoute - A wrapper component for voluntary insurance routes
 * Redirects to home if user is not authenticated
 */
const VoluntaryInsuranceRoute = ({ children }: RouteWrapperProps) => {
  return getAccessToken() ? <>{children}</> : <Navigate to="/" replace />;
};

export default VoluntaryInsuranceRoute;
